import type { WorkflowRunMissingSourcePayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A document to carry over that the dossier does not have: it must be chosen by hand before generating.
 */
class WorkflowRunMissingSourceView {
	readonly documentTypeId: number;
	readonly verifiedOnly: boolean;

	constructor(payload: WorkflowRunMissingSourcePayload) {
		this.documentTypeId = payload.documentType.id;
		this.verifiedOnly = payload.verifiedOnly;

		Object.freeze(this);
	}
}

export default WorkflowRunMissingSourceView;
